import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-096d84b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-background" }, null, -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round icon" }, "merge_type", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Handle = _resolveComponent("Handle")!
  const _component_flow_node_wrapper = _resolveComponent("flow-node-wrapper")!

  return (_openBlock(), _createBlock(_component_flow_node_wrapper, {
    name: _ctx.data.name,
    description: _ctx.data.description || ''
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Handle, {
            class: _normalizeClass(["handle target-handle", { active: _ctx.data.showHandle }]),
            type: "target",
            position: "left"
          }, null, 8, ["class"]),
          _createElementVNode("div", {
            class: _normalizeClass(["target-handle-dot", { active: _ctx.data.showHandle }])
          }, null, 2),
          _createVNode(_component_Handle, {
            class: "handle source-handle",
            type: "source",
            position: "left"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.outlets, (outlet, k) => {
            return (_openBlock(), _createBlock(_component_Handle, {
              key: k,
              class: "extra-handle",
              type: "source",
              position: "right",
              id: k
            }, null, 8, ["id"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["name", "description"]))
}